import { createSafeContext } from '@/util';

const FileBrowserContext = createSafeContext();

export default FileBrowserContext;
